import { Component, OnInit} from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ProvidersService} from '../../services/providers.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
    selector: 'app-update-modal',
    templateUrl: './update-modal.component.html',
    styleUrls: ['./update-modal.component.scss']
})
export class UpdateModalComponent extends ModalExtended implements OnInit {

    formSearch: FormGroup;
    provider: any={};
    data: any;
    enabled: boolean = false;

    constructor(private providerService: ProvidersService, private alerta:AlertaService) {
        super();

        this.formSearch = new FormGroup({
                'name' : new FormControl(null,Validators.required),
                'label' : new FormControl(),
                'comments' : new FormControl()
            }
        );
    }

    ngOnInit() {
        if (this.data.data) {
            this.provider=this.data.data;
            this.formSearch.controls['name'].setValue(this.provider.name);
            this.formSearch.controls['label'].setValue(this.provider.label);
            this.formSearch.controls['comments'].setValue(this.provider.comments);
            }
    }

    updateProvider(form){
        if (form.valid) {
            this.enabled = true;
            let provider = this.formSearch.value;
            this
                .providerService
                .putServiceProvider(this.provider['pk'], provider)
                .subscribe(
                    (result) => {
                        this.onExit({ edit: true, element: result.data});
                        this.enabled = false;
                        this.alerta.addAlert('success','Provider Updated Succesfully!!')
                    }
                );
        }
    }

    saveProvider(form) {
        if (form.valid) {
            this.enabled = true;
            let provider=this.formSearch.value;
            this
                .providerService
                .postServiceProvider(provider)
                .subscribe(result => {
                    this.onExit({ edit:false, element: result.data });
                    this.enabled = false;
                    this.alerta.addAlert('success','Provider Updated Succesfully!!')
                }
            );
        }
    }

    onExit(provider) {
        this.applyCallback(provider);
        this.close();
    }

    protected generateLabel
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/providers/modals/update-modal/update-modal.component.ts